export default __webpack_public_path__ + "static/media/photo14.ae8468a0.jpeg";